import DivisionsFiltersForm from '@features/filters/interfaces/divisions-filters-form.interface';
import { FiltersStates } from '@features/filters/interfaces/filters.interfaces';
import { DivisionCliente } from '@interfaces/firestore-documents.interfaces';
import { Dispatch, KeyboardEventHandler, SetStateAction } from 'react';

export function searchDivisions(
	divisions: DivisionCliente[],
	filters: DivisionsFiltersForm,
	setDivisions: (data: DivisionCliente[]) => void
): void {
	const newData = [];
	for (const division of divisions) {
		// Filtrar por estado de la división.
		if (
			(filters.state === FiltersStates.Enabled && !division.activo) ||
			(filters.state === FiltersStates.Disabled && division.activo)
		) {
			continue;
		}

		// Filtrar por nombre o código de división.
		if (
			filters.division.length > 0 &&
			!division.nombre_div.toLowerCase().includes(filters.division.toLowerCase()) &&
			!division.codigo_div.toString().includes(filters.division)
		) {
			continue;
		}

		// Filtrar por proceso.
		if (
			filters.process.length > 0 &&
			!division.procesos.some(
				(p) =>
					p.nombre_proceso.toLowerCase().includes(filters.process.toLowerCase()) ||
					p.id_proceso_text.includes(filters.process)
			)
		) {
			continue;
		}

		newData.push(division);
	}

	setDivisions(newData.sort((a, b) => a.codigo_div.localeCompare(b.codigo_div)));
}

export function handleFiltersClearClick(
	toClear: 'division' | 'process',
	divisions: DivisionCliente[],
	filters: DivisionsFiltersForm,
	setDivisions: (data: DivisionCliente[]) => void,
	setSearchedProcess: Dispatch<SetStateAction<string>>,
	setDivisionKeyPress: Dispatch<SetStateAction<boolean>>,
	setProcessKeyPress: Dispatch<SetStateAction<boolean>>
): () => void {
	return function () {
		const newFilters = filters;
		if (toClear === 'division') {
			newFilters.division = '';
			setDivisionKeyPress(false);
		} else if (toClear === 'process') {
			newFilters.process = '';
			setSearchedProcess('');
			setProcessKeyPress(false);
		}

		searchDivisions(divisions, newFilters, setDivisions);
	};
}

export function handleFiltersKeyPress(
	divisions: DivisionCliente[],
	filters: DivisionsFiltersForm,
	setDivisions: (data: DivisionCliente[]) => void,
	setSearchedProcess: Dispatch<SetStateAction<string>>,
	setDivisionKeyPress: Dispatch<SetStateAction<boolean>>,
	setProcessKeyPress: Dispatch<SetStateAction<boolean>>
): KeyboardEventHandler<HTMLInputElement> {
	return async function (e) {
		if (e.key === 'Enter') {
			searchDivisions(divisions, filters, setDivisions);
			await setSearchedProcess(filters.process);
			if (document.getElementsByClassName('searched').length > 0) {
				document.getElementsByClassName('searched')[0].scrollIntoView();
			}
			if (filters.division !== '') {
				setDivisionKeyPress(true);
			} else {
				setDivisionKeyPress(false);
			}
			if (filters.process !== '') {
				setProcessKeyPress(true);
			} else {
				setProcessKeyPress(false);
			}
		}
	};
}
